import { NumberRangeValue } from "../components/form/inputs/NumberRange";

export type Rule =
  | OnThe_Rule
  | Every_Rule
  | After_Rule
  | Before_Rule
  | At_Rule
  | On_Rule
  | Of_Rule
  | In_Rule;

export const RULE_TYPES = [
  "on_the",
  "every",
  // "after",
  // "before",
  // "at",
  // "on",
  // "of",
  // "in",
] as const;

export type RuleType = (typeof RULE_TYPES)[number];
export type SpecificRule<T extends RuleType> = Extract<Rule, { type: T }>;

type OnThe_Rule = {
  type: "on_the";
  relativeTime?: "first" | "last";

  // these values are only set when the periodType is not set
  numberRange?: NumberRangeValue;
  period?: string;
};

type Every_Rule = {
  type: "every";
  periodType?: "weekend" | "weekday";

  // these values are only set when the periodType is not set
  number?: number;
  period?: string;
  timeRange?: "starting_on_the" | "between_the";
  timeRangeNumberStart?: number; // this is only set when timeRange is "between_the" or "starting_on_the"
  timeRangeNumberEnd?: number; // this is only set when timeRange is "between_the"
};

type After_Rule = {
  type: "after";
  period?: string;
  number?: number;
};

type Before_Rule = {
  type: "before";
  period?: string;
};

type At_Rule = {
  type: "at";
  period?: string;
};

type On_Rule = {
  type: "on";
  period?: string;
};

type Of_Rule = {
  type: "of";
  period?: string;
};

type In_Rule = {
  type: "in";
  period?: string;
};
